import React, { Component } from "react";
import { Button, Icon, Form } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import './styles.scss';
import {
    getTotalRecordDetailList,
    deleteTotalRecordDetailList
} from "../../core/actions/totalRecordDetailAction";
import { exportFileAction } from "../../core/actions/commonAction";
import TableDateCustom from '../../components/ProjectTableDate';
import TableDateBusiness from '../../components/ProjectTableBusiness';
import functionCommon from "../../core/common/function";
import UpdateWorklogModal from '../../components/UpdateWorklogModal';
import AddNewProjectModal from '../../components/AddNewProjectModal'
import moment from 'moment';

class TotalRecordDetail extends Component {
    constructor(props) {
        super(props);
        const regex = /[?&]([^=#]+)=([^&#]*)/g;
        const url = window.location;
        let  params = {};
        let match;
        while(match = regex.exec(url)) {
            params[match[1]] = match[2];
        }
        if(!params['employeeId']) {
            window.location = '/total-record';
        }
        this.state = {
            urlParams: params,
            paramList: {
                employeeId: params.employeeId,
                month: params.month,
                year: params.year,
                sortBy: "createdDate-desc",
            },
            paramDelete: {
                employeeId: params.employeeId,
                month: params.month,
                year: params.year
            },
            tableProjectStructure: [ 
                {
                    label: 'labels.project',
                    type: 'projectCode',
                    typeCombine: 'projectName',
                    mainType: 'project',
                    isClass: 'inquiry-first-col',
                    fixed: 'left',
                    width: 210
                },
                {
                    label: 'labels.totalHours',
                    type: 'totalHours',
                    fixed: 'left',
                    width: 70
                },
            ],
            tableBusinessStructure: [
                {
                    label: 'labels.item',
                    type: 'item',
                    fixed: 'left'
                },
            ],
            projectId: "",
            data: [],
            dataBusinessTime: {},
            errorCode: "",
            successCode: "",
            exportDisabled: false,
            isFirstLoad: true,
            open: false,
            paramUpdate: {
                employeeId: params.employeeId,
                projectId: "",
                date: "",
                approverSort: 'lastName-ASC'
            }, 
            modalStyle: "",
            paramAddNew: {
                employeeId: params.employeeId,
                projectSort: 'projectCode-ASC',
                employeeSort: 'employeeCode-ASC',
                approverSort: 'lastName-ASC'
            },
            loading: true
        }
    }

    componentWillMount() {
        // Call API position-list, show list position
        this.props.getTotalRecordDetailList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.totalRecordDetailReducer.isLoading) {
            this.props.getTotalRecordDetailList(this.state.paramList);
        } else {
            this.clearTableProjectStructure();
            const data = nextProps.totalRecordDetailReducer.dataTotal;
            const date = functionCommon.dateInMonth(this.state.paramList.month, this.state.paramList.year);
            const employeeCode = nextProps.totalRecordDetailReducer.dataTotal.listData.employeeCode;
            const employeeName = nextProps.totalRecordDetailReducer.dataTotal.listData.employeeName;
            const month = nextProps.totalRecordDetailReducer.dataTotal.listData.month;
            const year = nextProps.totalRecordDetailReducer.dataTotal.listData.year;
            if(data['totalHourByProjectCode']){
                let _totalHourByProjectCode = data['totalHourByProjectCode']
                for (var key in _totalHourByProjectCode) {
                    data['listData']['workLog'].forEach(workLog => {
                        if(workLog.projectCode === key){
                            workLog["totalHours"] = this.fixDecimal(_totalHourByProjectCode[key]);
                        }
                    });
                }
            }
            
            date.forEach(item => {
                this.setState(prevState => ({
                    tableProjectStructure: prevState.tableProjectStructure.concat(
                        {
                            label: item.dateConvert,
                            type: "normalTime",
                            isClass: item.isSunOrSa ? 'sun-sat-class' : '',
                            isDate: true,
                            subType: "workLogDate",
                            isValueInArray: true,
                            checkValue: item.date,
                            day: item.day,
                            width: 70
                            
                        }
                    )
                }));
                this.setState(prevState => ({
                    tableBusinessStructure: prevState.tableBusinessStructure.concat(
                        {
                            label: item.dateConvert,
                            type: "normalTime",
                            isClass: item.isSunOrSa ? 'sun-sat-class' : '',
                            isDate: true,
                            subType: "workLogDate",
                            isValueInArray: true,
                            checkValue: item.date  
                        }
                    )
                }));
            });
            
            // No data
            if (!data['listData']['workLog'] || (data['listData']['workLog'] && !data['listData']['workLog'][0])) {
                this.setState({
                    exportDisabled: true
                });
            } else {
                this.setState({
                    exportDisabled: false
                });
            }
    
            let errorCode = nextProps.totalRecordDetailReducer.errorCode;
            // Have error code
            if (errorCode) {
                if((errorCode !== "018" && this.state.open ===  false) || (errorCode === "018" && this.state.isFirstLoad === true && this.state.open ===  false)) {
                    this.setState({
                        errorCode: errorCode,
                    }); 
                    setTimeout(
                        function () {
                            this.setState({ errorCode: "" });
                            errorCode = "";
                        }.bind(this),
                        2000
                    );
                }
                
            }
            
            // Data have success code
            if (nextProps.totalRecordDetailReducer.successCode) {
                this.setState({
                    successCode: nextProps.totalRecordDetailReducer.successCode,
                });
               
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.totalRecordDetailReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }
            
            this.setState({
                data: data['listData']['workLog'],
                dataBusinessTime: data['businessTime'],
                totalOTByDate: data['totalHourByDate'],
                totalAllProject: this.fixDecimal(data['totalHourAllProjectCode']),
                pic: employeeCode + ' - ' + employeeName,
                period: month + ' - ' + year,
                loading: false
            });
        }
       
    }

    //clear table structure
    clearTableProjectStructure = () => {
        this.setState({
            tableProjectStructure: [
                {
                    label: 'labels.project',
                    type: 'projectCode',
                    typeCombine: 'projectName',
                    mainType: 'project',
                    isClass: 'inquiry-first-col',
                    fixed: 'left',
                    width: 210
                },
                {
                    label: 'table.total',
                    type: 'totalHours',
                    fixed: 'left',
                    width: 70
                }
    
            ],
            tableBusinessStructure: [
                {
                    label: 'labels.item',
                    type: 'item',
                    fixed: 'left'
                }
            ]
        })
    }

    // Event when click btn Export
    inquiryDataExportAction = () => {
        const exportParam = {
            employeeId: this.state.paramList.employeeId,
            month: this.state.paramList.month,
            year: this.state.paramList.year,
            projectId: "",
            sortBy: this.state.paramList.sortBy,
            projectBy: "projectName-asc"
        };
        this.props.exportFileAction({
            'urlGetkey': 'WorkLog/requestSecretKey',
            'urlDownfile':  'WorkLog/inquiryData'
        }, exportParam)
    }

    // Delete ER
    deleteER = () => {
        this.setState({
            isFirstLoad: false
        })
        return this.props.deleteTotalRecordDetailList(this.state.paramDelete);
    }

    // Popup event
    showModal = (size, modalStyle) => this.setState({ size, open: true, modalStyle: modalStyle })

    closeModal = async() => {
        this.setState({ open: false, modalStyle: '' });
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                projectNewId: ""
            }
        }));
        return this.props.getTotalRecordDetailList(this.state.paramList);
    }

    cancelModal = () => {
        this.setState({ open: false, modalStyle: '' });
    }

   // Event when click table cell
   onCellClick = (val, projectId) => {
    if(val.isDate) {
        let date = val.checkValue;
        date = moment(date).format("YYYY-MM-DD")
        this.setState(prevState => ({
            paramUpdate: {
                ...prevState.paramUpdate,
                projectId: projectId,
                date: date
            }
        }));
        this.showModal('tiny', 'update'); 
    }
}

    addNewProject = () => {
        this.showModal('tiny', 'addNew'); 
    }

    fixDecimal = (val) => {
        return (functionCommon.isDecimal(val)) 
        ? Number(parseFloat(val).toFixed(2)) 
        : val
    }

    render() {
        const { t } = this.props;
        const { errorCode, successCode, pic, period, size, open, paramUpdate, paramAddNew, urlParams } = this.state;
        return (
            <div className="inquiry-data-form total-record-detail-form">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/' }, 500)}>
                        {t("navigation.engineerHourRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/total-record?month=' + urlParams.month + 
                    '&year='+ urlParams.year +'&searchBy=' + urlParams.searchBy + '&projectId=' + urlParams.projectId}, 500)}>
                        {t("navigation.totalRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.detail")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        onClick={() => this.addNewProject()}
                    >
                        <Icon name="add circle" />
                        {t("button.addNewProject")}
                    </Button>
                    <Button
                        primary
                        onClick={() => this.deleteER()}
                    >
                        <Icon name='trash alternate outline' />{t('button.delete')} ER
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.inquiryDataExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                </div>
                <div className="employee-form total-detail-form">
                    <Form>
                        <Form.Group>
                            <label className="total-detail-label">{t('labels.pic')}</label>
                            <label className="text-blue">{pic}</label>
                        </Form.Group>
                        <Form.Group>
                            <label className="total-detail-label">{t('labels.period')}</label>
                            <label className="text-blue">{period}</label>
                        </Form.Group>
                    </Form>
                </div>
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}  
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <div className="table-responsive">
                    <TableDateCustom
                        tableStructure={this.state.tableProjectStructure}
                        dataList={this.state.data}
                        totalOTDate={this.state.totalOTByDate}
                        onCellClick={(val, projectId) => this.onCellClick(val, projectId)}
                        defaultSort={this.state.paramList.sortBy}
                        isTotal={true}
                        totalAllProject={this.state.totalAllProject}
                        isTotalFirst={true}
                        maxHeight="345"
                        width="1170"
                        loading={this.state.loading}
                    />
                </div>
                <div className="table-responsive">
                    <TableDateBusiness
                        tableStructure={this.state.tableBusinessStructure}
                        dataList={this.state.dataBusinessTime}
                    />
                </div>
                {
                    this.state.modalStyle == 'update' ?   
                    <UpdateWorklogModal 
                        size={size} 
                        open={open} 
                        handleClose={this.closeModal}
                        handleCancel={this.cancelModal}
                        modalStyle={this.state.modalStyle}
                        param={paramUpdate}
                    /> : ''
                }
                {
                    this.state.modalStyle == 'addNew' ?   
                    <AddNewProjectModal
                        size={size} 
                        open={open} 
                        handleClose={this.closeModal}
                        handleCancel={this.cancelModal}
                        modalStyle={this.state.modalStyle}
                        param={paramAddNew}
                        pic={this.state.pic}
                        employeeId={this.state.paramList.employeeId}
                    /> : ''
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getTotalRecordDetailList: opt => dispatch(getTotalRecordDetailList(opt)),
    deleteTotalRecordDetailList: opt => dispatch(deleteTotalRecordDetailList(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(TotalRecordDetail);
